import { createSelector } from '@ngrx/store';
import { UserProfileState } from '../reducers/user-profile.reducers';
import { RootState } from '../root/root-state.model';

export const userProfileState = (state: RootState) => state.userProfile;

export const selectPSL = createSelector(
  userProfileState,
  (state: UserProfileState) => {
    return state.chosenPSL;
  },
);

export const selectAvailablePSLs = createSelector(
  userProfileState,
  (state: UserProfileState) => {
    return state.availablePSLs;
  },
);

export const selectDropdownPSLs = createSelector(
  userProfileState,
  (state: UserProfileState) => {
    return state.availablePSLs.map((psl) => ({
      name: psl.name,
      id: psl.id,
      code: psl.code || '',
    }));
  },
);

export const selectUoMSetting = createSelector(
  userProfileState,
  (state: UserProfileState) => {
    return state.uomSetting;
  },
);

export const selectUserProfileError = createSelector(
  userProfileState,
  (state: UserProfileState) => {
    return state.error;
  },
);
